const BudgetsApp = () => {
  return (
    <div>
      <h1>Budgets App</h1>
    </div>
  );
};

export default BudgetsApp;
